import React from 'react';
import Logo from './Logo';

const Hero: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 text-white py-24 lg:py-36 overflow-hidden">
      {/* Subtle grid overlay */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            'linear-gradient(rgba(99,179,237,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(99,179,237,0.3) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      />
      {/* Glow accents */}
      <div className="absolute top-10 left-1/4 w-96 h-96 bg-blue-600 rounded-full filter blur-3xl opacity-10 pointer-events-none" />
      <div className="absolute bottom-10 right-1/4 w-96 h-96 bg-indigo-600 rounded-full filter blur-3xl opacity-10 pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          {/* Logo lockup */}
          <div className="mb-8">
            <Logo size="lg" textColor="white" />
          </div>

          {/* Eyebrow */}
          <p className="text-blue-400 text-sm font-semibold uppercase tracking-widest mb-4">
            Custom Software · Cloud · AI
          </p>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-8 tracking-tight">
            We build custom software for restaurants and small businesses that want to{' '}
            <span className="text-blue-400">stop losing money to manual work.</span>
          </h1>

          {/* CTA row */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <a
              href="#contact"
              className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-500 text-white font-semibold text-base px-8 py-3.5 rounded-lg transition-all duration-200 shadow-lg shadow-blue-900/40 hover:shadow-blue-700/50 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-slate-900"
            >
              Start a Project
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center border border-slate-500 hover:border-blue-400 text-slate-200 hover:text-white font-semibold text-base px-8 py-3.5 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-slate-900"
            >
              See Our Services
            </a>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {[
            { value: 'Founding 2026', label: 'New shop, modern stack' },
            { value: 'AWS · Azure · GCP', label: 'Cloud-native by default' },
            { value: 'EN / ES', label: 'Bilingual team' },
            { value: 'Source code yours', label: 'No lock-in, no black boxes' },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white/5 border border-white/10 rounded-xl px-5 py-5 text-left backdrop-blur-sm hover:bg-white/10 transition-colors"
            >
              <div className="text-xl font-bold text-blue-400 mb-1">{stat.value}</div>
              <div className="text-sm text-slate-400 font-medium leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
